import { Component, Input, Output, EventEmitter } from '@angular/core';
import { IWebshopAccessSettings } from './webshop-access-settings-data.service';
import { UntypedFormGroup } from '@angular/forms';

// component loaded in a custom field to achieve a custom layout
// https://acslworld.atlassian.net/wiki/spaces/DEV/pages/692584474/Webshop+Access+Settings

@Component({
  selector: 'user-approval-radio-fields',
  template: `
    <div class="row">
      <div class="col-sm-6">
        <label class="form-check form-check-inline no-padding-left">
          <input type="radio" name="user-approval" [(ngModel)]="model.userApproval" [value]="true" (click)="onChange.emit(true)" value="true"  />
          <strong class="form-check-label ps-2 fw-bold"><text key="MANUAL_APPROVAL_LABEL"></text></strong>
        </label>
        <p class="info-row margin-top-sm" [ngClass]="{ 'disabled-control': !model.userApproval }"><text key="MANUAL_APPROVAL_INFO"></text></p>
      </div>

      <div class="col-sm-6">
        <label class="form-check form-check-inline no-padding-left">
          <input type="radio" name="user-approval" [(ngModel)]="model.userApproval" [value]="false" (click)="onChange.emit(false)" value="false" />
          <strong class="form-check-label ps-2 fw-bold"><text key="AUTO_APPROVAL_LABEL"></text></strong>
        </label>
        <p class="info-row margin-top-sm" [ngClass]="{ 'disabled-control': model.userApproval }"><text key="AUTO_APPROVAL_INFO"></text></p>
      </div>
    </div>
	`
})
export class UserApprovalRadioFieldsComponent {
  @Input() public model:IWebshopAccessSettings;
  @Output() public onChange:EventEmitter<boolean> = new EventEmitter();

  public form:UntypedFormGroup = new UntypedFormGroup({});
}